import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Row, Typography } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from '../ImportClientsModal.module.scss';
import { FailuresCallout } from './FailuresCallout';
import { SaveErrorsCallout } from './SaveErrorsCallout';
export const GetResultViewTID = (parentTestId)=>getTestIds(parentTestId);
export function ResultView(param) {
    let { response, testId } = param;
    const { t: resultsTexts } = useLocaleKeys('pages.importClients.results');
    const { ResultViewTestIds: TID } = useMemo(()=>GetResultViewTID(testId), [
        testId
    ]);
    const { customersCreated, contactsAdded, failures, customersWithSaveErrors, unreadableRows } = response;
    const showFailuresCallout = failures.length > 0 || unreadableRows.length > 0;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                alignItems: "center",
                testId: TID.Summary(),
                children: [
                    /*#__PURE__*/ _jsx(Checkmark, {
                        size: 20,
                        className: styles.checkmark
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        weight: "light",
                        children: resultsTexts.summary({
                            created: customersCreated,
                            contactsAdded
                        })
                    })
                ]
            }),
            showFailuresCallout && /*#__PURE__*/ _jsx(FailuresCallout, {
                failures: failures,
                unreadableRows: unreadableRows,
                testId: TID.FailuresCallout()
            }),
            customersWithSaveErrors.length > 0 && /*#__PURE__*/ _jsx(SaveErrorsCallout, {
                saveErrors: customersWithSaveErrors,
                testId: TID.SaveErrorsCallout()
            })
        ]
    });
}
